import { useEffect, useRef, useState } from "react";
import { Mail, Phone, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button } from "@mui/material";

const FloatingContactButton = () => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <Box
      ref={containerRef}
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 40,
      }}
    >
      <Box sx={{ position: "relative" }}>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              style={{
                marginBottom: 16,
                display: "flex",
                flexDirection: "column",
                gap: 8,
                backgroundColor: "#fff",
                borderRadius: 12,
                padding: 16,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ddd",
              }}
            >
              <Button
                component={RouterLink}
                to="/contact"
                startIcon={<Mail size={18} />}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#FFEDD5",
                  color: "#C2410C",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  justifyContent: "flex-start",
                  "&:hover": {
                    backgroundColor: "#FED7AA",
                  },
                }}
              >
                Contactez notre boîte mail
              </Button>

              <Button
                href="tel:0628124774"
                startIcon={<Phone size={18} />}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#DCFCE7",
                  color: "#15803D",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  justifyContent: "flex-start",
                  "&:hover": {
                    backgroundColor: "#BBF7D0",
                  },
                }}
              >
                Appelez-nous maintenant
              </Button>
            </motion.div>
          )}
        </AnimatePresence>

        <Button
          onClick={() => setOpen(!open)}
          startIcon={open ? <X size={20} /> : <Phone size={20} />}
          sx={{
            textTransform: "none",
            backgroundColor: "#c84653",
            color: "#fff",
            fontWeight: 600,
            fontSize: "0.875rem",
            padding: "12px 20px",
            borderRadius: 999,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: "#c84653",
            },
          }}
        >
          Appelez-nous maintenant
        </Button>
      </Box>
    </Box>
  );
};

export default FloatingContactButton;
